import React from "react";
import { useTranslation } from "react-i18next";
function CategoryFilterTop({
  filters,
  setFilters,
  onApply,
  availableFilters,
  filtersCount,
  onReset,
}) {
  const { t } = useTranslation();
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]:
        value === "" ||
        value === "Color" ||
        value === "Material" ||
        value === "Sort by"
          ? ""
          : value,
    }));
  };

  return (
    <>
      <div className="border-bottom py-3">
        <button
          className="btn btn-outline-dark fs-11 rounded-pill pe-4 px-4 mx-3"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasRight"
          aria-controls="offcanvasRight"
        >
          {t("Filters")} ({filtersCount}){" "}
          <i className="fas fa-filter fa-sm"></i>
        </button>

        <div
          className="offcanvas offcanvas-end"
          tabIndex="-1"
          id="offcanvasRight"
          aria-labelledby="offcanvasRightLabel"
        >
          <div className="offcanvas-header">
            <h5 id="offcanvasRightLabel">{t("Filters")}</h5>
            <button
              type="button"
              className="btn-close text-reset"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            ></button>
          </div>

          <div className="offcanvas-body">
            <div className="row justify-content-center">
              <div className="col-lg-12 text-start">
                {/* Color Filter */}
                <div className="mb-3">
                  <label className="form-label">{t("Color")}</label>
                  <select
                    name="color"
                    className="form-select p-3"
                    onChange={handleChange}
                    value={filters.color || ""}
                  >
                    <option>{t("Color")}</option>
                    {availableFilters.color?.map((c, i) => (
                      <option key={i} value={c}>
                        {c}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Material Filter */}
                <div className="mb-3">
                  <label className="form-label">{t("Material")}</label>
                  <select
                    name="material"
                    className="form-select p-3"
                    onChange={handleChange}
                    value={filters.material || ""}
                  >
                    <option>{t("Material")}</option>
                    {availableFilters.material?.map((m, i) => (
                      <option key={i} value={m}>
                        {m}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Sort Filter */}
                <div className="mb-3">
                  <label className="form-label">{t("Sort by")}</label>
                  <select
                    name="sortBy"
                    className="form-select p-3"
                    onChange={handleChange}
                    value={filters.sortBy || ""}
                  >
                    <option>{t("Sort by")}</option>
                    <option value="asc">{t("Price: Low to High")}</option>
                    <option value="desc">{t("Price: High to Low")}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div className="offcanvas-footer p-4">
            <button
              className="btn bgcolorfooterbottom w-100 p-3"
              data-bs-dismiss="offcanvas"
              onClick={onApply}
            >
              {t("ShowProducts")}
            </button>
            <button
              className="btn w-100 p-2 text-decoration-underline"
              onClick={onReset}
            >
              {t("ResetFilters")}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default CategoryFilterTop;
